import { useDispatch } from "react-redux";

import DefRoutes from "../../../routes/routes.json";
import { SignOut } from "../../../store/reducers/auth.reducer";

function Lougout() {
  const dispath = useDispatch();

  dispath(SignOut());

  window.location = DefRoutes.Home;

  return <div />;
}

export default Lougout;
